import { Component, TemplateRef, inject, input, output, viewChild, linkedSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { InputErrorsComponent } from '../../../../components/form/input-errors/input-errors.component';
import { ConfirmButtonComponent } from '../../../../components/confirm/confirm-button.component';
import { FormComponent } from '../../../../components/form/form.component';
import { ConfirmButtonsComponent } from '../../../../components/confirm/confirm-buttons.component';
import { ConfirmTitleComponent } from '../../../../components/confirm/confirm-title.component';
import { ModalRef } from '../../../../components/modal/modal-ref';
import { ModalService } from '../../../../components/modal/modal.service';
import { InputGroupFieldComponent } from '../../../../components/form/input-group/input-group-field.component';
import { InputDirective } from '../../../../components/input/input.directive';
import { ConfirmComponent } from '../../../../components/confirm/confirm.component';
import { InputGroupComponent } from '../../../../components/form/input-group/input-group.component';
import { InvestmentGoal } from '../../../../domain/lti/lti.domain';
import { ConfirmBodyComponent } from '../../../../components/confirm/confirm-body.component';

import { DashboardRestService } from '../dashboard-rest.service';

@Component({
  selector: 'td-wb-lti-goal-rename',
  templateUrl: './goal-rename.component.html',
  styleUrls: ['./goal-rename.component.scss'],
  exportAs: 'tdWbLtiGoalRename',
  imports: [
    ConfirmComponent,
    ConfirmTitleComponent,
    ConfirmBodyComponent,
    FormComponent,
    InputGroupComponent,
    InputGroupFieldComponent,
    TranslatePipe,
    TranslateDirective,
    FormsModule,
    InputErrorsComponent,
    ConfirmButtonsComponent,
    ConfirmButtonComponent,
    InputDirective
  ]
})

export class GoalRenameComponent {
  private readonly modalService = inject(ModalService);
  private readonly dashboardRestService = inject(DashboardRestService);

  readonly goal = input<InvestmentGoal>(undefined);
  readonly goalNameChange = output<string>();

  readonly goalRename = viewChild<TemplateRef<unknown>>('goalRenameTemplate');

  /** Local editable copy of goal name, auto-synced when input changes */
  readonly goalName = linkedSignal(() => this.goal()?.name ?? '');

  private confirmModal: ModalRef<unknown>;

  open(): void {
    const previousName = this.goalName();
    this.confirmModal = this.modalService.open(this.goalRename(), {
      size: 'extra-small'
    });

    this.confirmModal.afterClose().subscribe((result: unknown): void => {
      this.updateGoalName(result !== 'CANCEL', previousName);
    });
  }

  private updateGoalName(close: boolean, previousGoalName: string): void {
    const goal = this.goal();
    if (close && this.goalName() !== undefined && this.goalName() !== '' && goal?.id !== undefined) {
      this.dashboardRestService.updateInvestmentGoal({ goalId: goal.id },
        { name: this.goalName(), subType: goal.subType, targetAmount: goal.targetAmount })
        .subscribe({
          error: (): void => {
            this.goalName.set(previousGoalName);
          },
          complete: (): void => {
            this.goalNameChange.emit(this.goalName());
          }
        });
    } else {
      this.goalName.set(previousGoalName);
      this.goalNameChange.emit(this.goalName());
    }
  }
}
